import React from "react";
import { Box, Paper, Typography, Grid } from "@mui/material";
import EventNoteIcon from "@mui/icons-material/EventNote";
import DescriptionIcon from "@mui/icons-material/Description";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import BusinessIcon from "@mui/icons-material/Business";
import BadgeIcon from "@mui/icons-material/Badge";

// Vista de inicio para los roles que no tienen acceso al dashboard de
// reporteria: una grilla con los mismos destinos que ya trae su menu lateral.
const ACCESOS_POR_ROL = {
  "COMERCIAL": ["asesor", "agendas", "helpdesk", "inhouse"],
  "REDES SOCIALES": ["asesor", "agendas", "helpdesk", "inhouse"],
  "DIRECCION-ACADEMICA": ["agendas", "helpdesk", "inhouse"],
  _default: ["agendas", "helpdesk"],
};

const ACCESOS = {
  agendas: {
    label: "Agendas Mensuales",
    descripcion: "Programación, eventos y agendas del mes",
    icon: <EventNoteIcon />,
    href: () => process.env.REACT_APP_REDIRECT_ADMINISTRATIVO,
  },
  formularios: {
    label: "Formularios",
    descripcion: "Formularios y pruebas diagnósticas",
    icon: <DescriptionIcon />,
    href: () => process.env.REACT_APP_REDIRECT_FORMS,
  },
  helpdesk: {
    label: "Help Desk",
    descripcion: "Levantar y dar seguimiento a tickets de soporte",
    icon: <HeadsetMicIcon />,
    href: () => "/ticket-soporte",
  },
  inhouse: {
    label: "In House",
    descripcion: "Propuestas y formatos de eventos in house",
    icon: <BusinessIcon />,
    href: () => "/in-house",
  },
  asesor: {
    label: "Perfil Asesor Comercial",
    descripcion: "Tu perfil, metas y material comercial",
    icon: <BadgeIcon />,
    href: () => "/asesor-profile",
  },
};

const AccesosDirectos = ({ dataUsr }) => {
  const claves =
    ACCESOS_POR_ROL[dataUsr?.permisos] || ACCESOS_POR_ROL._default;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      <Box>
        <Typography sx={{ fontSize: 20, fontWeight: 700 }}>
          Hola, {dataUsr?.Username}
        </Typography>
        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
          Estos son tus accesos disponibles en el Portal EBG
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {claves.map((clave) => {
          const acceso = ACCESOS[clave];
          if (!acceso) return null;
          return (
            <Grid item xs={12} sm={6} lg={4} key={clave}>
              <Paper
                onClick={() => {
                  window.location.href = acceso.href();
                }}
                sx={{
                  p: 2.5,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.25,
                  cursor: "pointer",
                  transition: "border-color .15s, background-color .15s",
                  "&:hover": { borderColor: "#4da3d8", bgcolor: "#16283a" },
                }}
              >
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "rgba(77,163,216,0.12)",
                    color: "#4da3d8",
                  }}
                >
                  {acceso.icon}
                </Box>
                <Typography sx={{ fontSize: 15, fontWeight: 600 }}>
                  {acceso.label}
                </Typography>
                <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                  {acceso.descripcion}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default AccesosDirectos;
